var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, ModelSync } from 'vue-property-decorator';
import { BRow, BCol, BFormCheckbox } from 'bootstrap-vue';
import TabHeading from 'components/picture-frames/Tabs/TabHeading.vue';
import FrameExtra from 'components/picture-frames/Tabs/FrameExtras/FrameExtra.vue';
let FrameExtras = class FrameExtras extends Vue {
    selectedExtras;
    rebateDimensions;
    glazing;
    get backingWarning() {
        return this.glazing ? 'You are required to have backing as you have requested glazing.' : null;
    }
    get glassDimensions() {
        return {
            width: this.rebateDimensions.width - 3,
            length: this.rebateDimensions.length - 3
        };
    }
};
__decorate([
    ModelSync('extras', 'change', { type: Object })
], FrameExtras.prototype, "selectedExtras", void 0);
__decorate([
    Prop(Object)
], FrameExtras.prototype, "rebateDimensions", void 0);
__decorate([
    Prop(Object)
], FrameExtras.prototype, "glazing", void 0);
FrameExtras = __decorate([
    Component({
        components: {
            BRow, BCol, BFormCheckbox,
            TabHeading, FrameExtra
        }
    })
], FrameExtras);
export default FrameExtras;
